import React, { useState, useEffect } from "react";
import { Nav, Tab } from "react-bootstrap";
import { SvgComponent } from "components";
import ItemList from "./ItemList";
import CategoriaList from "views/Categoria/CategoriaList";

const ItemMain = ({ hideLoading, showLoading, isActive, option }) => {
    const [currentTab, setCurrentTab] = useState();
    const iconStyle = { marginRight: "15px" };
    const iconColor = "#3f3f3f";
    const navStyle = { width: "100%", justifyContent: "center" };
    const paneStyle = { padding: "0px" };

    useEffect(() => {
        if (isActive) {
            if (option) setCurrentTab(option);
            else setCurrentTab("items");
        }
    }, [isActive, option]);

    const handleSelect = (eventKey) => {
        setCurrentTab(eventKey);
    };

    return (
        <Tab.Container
            id="icons-tabs"
            defaultActiveKey="items"
            activeKey={currentTab}
            onSelect={handleSelect}
        >
            <Nav className="ml-0" role="tablist" variant="tabs" fill>
                <Nav.Item>
                    <Nav.Link eventKey="items" style={navStyle}>
                        <SvgComponent
                            iconName="item"
                            fill={iconColor}
                            style={iconStyle}
                        />
                        Item
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="categoria" style={navStyle}>
                        <SvgComponent
                            iconName="category"
                            height="24"
                            width="24"
                            fill={iconColor}
                            style={iconStyle}
                        />
                        Categoría
                    </Nav.Link>
                </Nav.Item>
            </Nav>
            <Tab.Content>
                <Tab.Pane eventKey="items" style={paneStyle}>
                    <ItemList
                        hideLoading={hideLoading}
                        showLoading={showLoading}
                        isActive={currentTab === "items"}
                        hideTitle={true}
                    />
                </Tab.Pane>
                <Tab.Pane eventKey="categoria" style={paneStyle}>
                    <CategoriaList
                        hideLoading={hideLoading}
                        showLoading={showLoading}
                        isActive={currentTab === "categoria"}
                        hideTitle={true}
                    />
                </Tab.Pane>
            </Tab.Content>
        </Tab.Container>
    );
};
export default ItemMain;
